import React, { ReactNode } from 'react';

// Props definition for the component
export interface WideMetricCardProps {
  name: string; // Used to dynamically load the image
  quantity: string; // The quantity to display
  unit: string; // The unit for the quantity
  title: string;
  children?: ReactNode;
  width?: string;
  height?: number;
  color: string;
  borderColor: string;
  hasBorder?: boolean;
}

// Functional component
const WideMetricCard: React.FC<WideMetricCardProps> = ({
  title,
  name,
  quantity,
  unit,
  color,
  borderColor,
  hasBorder = true,
  children,
}) => {
  return (
    <div
      className={`bg-${color}   border-${borderColor}   p-2.5  `.concat(
        hasBorder
          ? ` border-1 shadow-custom2 border-${borderColor} rounded`
          : ` border-b-[1px] border-b-${borderColor} `,
      )}
    >
      <div className="flex space-x-2 ">
        <img className="w-8 h-8" src={`/assets/icons/gray-bg/${name}.svg`} alt={name} />
        <div className="space-y-2">
          <p className="text-gray-700  text-base leading-[1.875rem]">{title}</p>
          <p className="text-lg leading-4 ">{quantity.toLocaleString()}</p>
          <p className="text-sm text-gray-400 opacity-80 ">{unit}</p>
          <div>{children}</div>
        </div>
      </div>
    </div>
  );
};

export default WideMetricCard;
